module.exports = __webpack_public_path__ + "img/氧传感器.png";